import { TextField } from "@mui/material";
import DateAdapter from '@mui/lab/AdapterDateFns';
import DatePicker from '@mui/lab/DatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { useTranslation } from "react-i18next";


const DatePickerWrapper = ({ 
    label, 
    value, 
    onChange, 
    error,
    theme,
    required,
    maxDate,
    minDate,
    disabled = false,
    inputSx = {},
    disablePast = false,
    dataTestId = {
        inputId: null,
        errorId: null
    },
    useCustomInputStyle = true,
}) => {

    const { t } = useTranslation();

    return(
        <LocalizationProvider dateAdapter={DateAdapter}>
            <DatePicker
                label={label}
                value={value}
                onChange={onChange}
                maxDate={maxDate}
                disabled={disabled} 
                minDate={minDate}
                disablePast={disablePast}
                inputProps={{ "data-testid": dataTestId?.inputId }} 
                renderInput={(params) => 
                    <TextField 
                        disabled={disabled}
                        {...params} 
                        fullWidth 
                        sx={{ ...(useCustomInputStyle ? theme.typography.customInput : {}), ...inputSx }} 
                        {...error && {helperText: t(error), error: true}} 
                        FormHelperTextProps={{ "data-testid": dataTestId?.errorId }}
                        required={required}
                    />
                }
            />
        </LocalizationProvider>
    );
}

export default DatePickerWrapper;